<template>
  <vue-snotify v-click-outside="clickOutside" />
</template>
<script>
import { mapGetters } from "vuex";
import { displayAlert } from "@/components/mixins/displayAlert";
export default {
  mixins: [displayAlert],
  data() {
    return {};
  },
  computed: mapGetters({
    errors: "Alert/Errors/getVal",
    warnings: "Alert/Warnings/getVal",
    success: "Alert/getVal",
    info: "Alert/Info/getVal"
  }),
  watch: {
    errors(val) {
      if (val) {
        this.$snotify.clear();
        if (!!val.result && !!val.result.label) {
          this.displayError("", this.$t(val.result.label));
        } else if (val.message) {
          this.displayError("", val.message);
        }
      }
    },
    warnings(val) {
      if (val) {
        this.$snotify.clear();
        if (!!val.result && !!val.result.label) {
          this.displayWarning("", this.$t(val.result.label));
        } else if (val.message) {
          this.displayWarning("", val.message);
        }
      }
    },
    success(val) {
      if (val) {
        this.$snotify.clear();
        if (!!val.result && !!val.result.label) {
          this.displaySuccess("", this.$t(val.result.label), null);
        } else if (val.message) {
          this.displaySuccess("", val.message, null);
        }
      }
    },
    info(val) {
      if (val) {
        this.$snotify.clear();

        if (val.event) {
          // Custom Alert
          this.customAlertByEvent(val);
        } else {
          // Display info default
          let msg = "";
          if (!!val.result && !!val.result.label) {
            msg = this.$t(val.result.label);
          } else if (val.message) {
            msg = val.message;
          }
          this.displayInfo("", msg, null);
        }
      }
    }
  },
  methods: {
    customAlertByEvent(val) {
      console.log("Custom Alert: " + JSON.stringify(val));
      switch (val.event) {
        case "cp_close":
          {
            const config = {
              config: {
                showProgressBar: true,
                closeOnClick: true,
                closeOnClickOutside: true,
                timeout: 0,
                position: "rightBottom",
                type: "info",
                html:
                  '<div class="snotifyToast__title">Info</div><div class="snotifyToast__body">' +
                  this.$t("errors.cp_close") +
                  "</div><div class='snotify-icon snotify-icon--info'></div>",
                buttons: [
                  {
                    text: this.$t("misc.yes"),
                    action: () => location.reload(),
                    bold: true
                  },
                  {
                    text: this.$t("misc.no"),
                    action: toast => this.$snotify.remove(toast.id),
                    bold: true
                  }
                ]
              }
            };
            this.displayAlert(config, null);
          }
          break;
      }
    },
    clickOutside() {
      if (
        !!this.$snotify.notifications &&
        this.$snotify.notifications.length > 0 &&
        this.$snotify.notifications[0].config.closeOnClickOutside === true
      ) {
        this.$snotify.clear();
      }
    }
  }
};
</script>
<style lang="scss">
.snotifyToast__buttons button.btn-footer-panel {
  color: #026cff;
  text-transform: uppercase;
  margin: 10px 20px;
}
.snotifyToast__buttons button.btn-footer-panel:hover {
  color: #002680;
  background-color: #fff;
}
.snotifyToast__inner {
  color: #001027;
}
@media (min-width: 768px) {
  .snotify-centerTop,
  .snotify-centerCenter,
  .snotify-centerBottom {
    left: calc(50% - 400px / 2);
  }
  .snotify {
    width: 400px;
  }
}
</style>
